import { gql } from '@apollo/client';



export const updateTaxation = gql`
  mutation updateTaxation(
    $entityId: String!
    $effectiveFrom: Date!
    $fixedStamp: Decimal!
    $fixedStampCurrency: String!
    $municipalityTax: Decimal!
    $proportionalStamp: Decimal!
    $reinsuranceTax: Decimal!
    $taxOnCommission: Decimal!
  ) {
    configuration {
      entities {
        taxation {
          configuration {
            updateTaxation(
              entityId: $entityId
              effectiveFrom: $effectiveFrom
              fixedStamp: $fixedStamp
              fixedStampCurrency: $fixedStampCurrency
              municipalityTax: $municipalityTax
              proportionalStamp: $proportionalStamp
              reinsuranceTax: $reinsuranceTax
              taxOnCommission: $taxOnCommission
            ) {
              id
              views {
                Configuration_all {
                  properties {
                    IsLatest
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;



export const createTaxationPlanSpecific = gql`
  mutation createTaxationPlanSpecific(
    $planSpecificTaxationInput: NewPlanSpecificTaxationInput!
  ) {
    core {
      createTaxationPlanSpecific(
        planSpecificTaxationInput: $planSpecificTaxationInput
      )
    }
  }
`;


